import React from "react";
import XIconRemoveButton from "../../../components/buttons/XIconRemoveButton";
import AirportPaginatedDropdown from "components/dropdowns/paginated/AirportPaginatedDropdown";

interface Props {
  onAirportSelected: (airport: server.dto.Airport) => void
  airport: server.dto.AirportSmall
  error: boolean
}

const RemovableAirport = (props: { airport: server.dto.AirportSmall, onAirportRemove: () => void }) => (<div className="flex gap">
  <XIconRemoveButton onClick={props.onAirportRemove} />
  <div>
    {props.airport.name} ({props.airport.iata})
    <div className="text-sublabel">{props.airport.location}</div>
  </div>
</div>
);

const AirportSelection = (props: Props) => {
  if (props.airport) {
    return <RemovableAirport airport={props.airport} onAirportRemove={() => { props.onAirportSelected(undefined); }} />;
  }

  return <AirportPaginatedDropdown
    value={props.airport}
    onChange={props.onAirportSelected}
    config={{
      isSearchable: true,
      hasError: props.error
    }}
  />;
};

export default AirportSelection;
